import React, { useCallback, useState, useEffect } from 'react';
import style from './style.module.scss';
import { Row, Col, Table, Form, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import File from './File';
import { OpenInNew } from '@material-ui/icons';
import ActionsRequestService from '../../services/action-request';
import Dialog from 'react-bootstrap-dialog';
import Can from 'components/Can';
import { useProfile } from 'models';

const FileUploadMultiple = ({
  files,
  setFiles,
  filesComments,
  setFilesComments,
  existingFiles,
  disabled,
  filesSaved
}) => {
  const profile = useProfile()
  const onDrop = useCallback(
    acceptedFiles => {
      const updateArray = [...files];
      if (filesComments) {
        const updateArrayComments = [...filesComments];

        acceptedFiles.forEach(file => {
          updateArrayComments.push({ value: '' });
        });

        setFilesComments(updateArrayComments);
      }

      acceptedFiles.forEach(file => {
        updateArray.push(file);
      });
      setFiles(updateArray);
    },
    [files, setFiles, filesComments, setFilesComments]
  );

  const [savedFiles, setSavedFiles] = useState([]);

  let dialog;

  useEffect(() => {
    if (!savedFiles || savedFiles.length == 0)
      setSavedFiles(filesSaved);
  });

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({ onDrop });

  const { t } = useTranslation();

  const handleChangeFileComment = (key, value) => {
    const updateArray = [...filesComments];
    updateArray[key].value = value;
    setFilesComments(updateArray);
  };

  const handleDeleteFile = key => {
    const updateArray = [...files];
    updateArray.splice(key, 1);
    setFiles(updateArray);

    if (filesComments) {
      const updateArrayComments = [...filesComments];
      updateArrayComments.splice(key, 1);
      setFilesComments(updateArrayComments);
    }
  };

  const handleDeleteFileSaved = (id) => {
    const updateArray = [...savedFiles];
    let files = ActionsRequestService.deleteFile(id);
    files
      .then(data => {
      });
    updateArray.map((f, k) => {
      if (f.id === id)
        updateArray.splice(k, 1);
    });
    setSavedFiles(updateArray);
  };

  const effectDeleteFile = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: "Excluir arquivo",
      body: t('phrase:are you sure?'),
      actions: [Dialog.CancelAction(), Dialog.OKAction(() => handleDeleteFileSaved(id))],
      bgSize: 'small',
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="file-tooltip" {...props}>
      Período de bloqueio para envio de NFs. A partir do dia
      primeiro do mês seguinte o sistema será reaberto para envio.
      Dúvidas consulte a seção de Perguntas e Respostas (FAQ).
    </Tooltip>
  );

  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const getProfile = () => {
    return profile;
  };

  const isBlocked = () => {
    return false 
    /*getDay() > 30 &&
      getDay() <= 31 &&
      getProfile() != 'Administrador'*/
  }

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row>
        {isBlocked() ? (
          <>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <Col>
                <div
                  {...getRootProps({
                    className:
                      style.dropzone + ' reject'
                  })}
                >
                  <input {...getInputProps()} disabled={true} />
                  <span>Período de bloqueio</span>
                </div>
              </Col>
            </OverlayTrigger>
          </>
        ) :
          <Col>
            {disabled ? <></> : (
              <div
                {...getRootProps({
                  className:
                    style.dropzone +
                    (isDragActive ? ' active' : '') +
                    (isDragAccept ? ' accept' : '') +
                    (isDragReject ? ' reject' : '')
                })}
              >
                <input {...getInputProps()} disabled={disabled} />
                {!isDragActive ? (
                  <span>{t('label:drag here')}</span>
                ) : isDragAccept ? (
                  <span>{t('label:drop now')}</span>
                ) : (
                  <span>{t('label:file not accepted')}</span>
                )}
              </div>
            )}
          </Col>
        }
      </Row>
      <Row
        className="mt-2"
        style={{ display: files.length > 0 || (filesSaved && filesSaved.length > 0) ? null : 'none' }}
      >
        <Col>
          <Table bordered hover>
            <thead>
              <tr>
                <th className="text-center align-middle">{t('label:file')}</th>
                {filesComments && (
                  <th className="text-center align-middle">
                    {t('label:comment')}
                  </th>
                )}
                <th width={1} className="text-center align-middle"></th>
                {!disabled ?
                  <th width={1} className="text-center align-middle"></th>
                  : <></>}
              </tr>
            </thead>
            <tbody>
              {savedFiles ? savedFiles.map((f, k) => {
                return (<tr key={k}>
                  <td className="text-center align-middle">{f.name}</td>
                  <td className="text-center align-middle">
                    <Form.Control
                      disabled={true}
                      value={!!f.description ? f.description : ""}
                    />
                  </td>
                  <td className="text-center align-middle">
                    <Can do="file.download" on="App">
                      <a className="type" href={f.url} target="_blank"><OpenInNew /></a>
                    </Can>
                  </td>
                  {!disabled ?
                    <td className="text-center align-middle">
                      <Can do="file.delete" on="App">
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => effectDeleteFile(f.id)}
                        >
                          <i className="fas fa-times">x</i>
                        </Button>
                      </Can>
                    </td>
                    : <></>}
                </tr>);
              }) : ''}
              {files.map((file, k) => (
                <tr key={k}>
                  <td className="text-center align-middle">{file.name}</td>
                  {filesComments && (
                    <td className="text-center align-middle">
                      <Form.Control
                        value={filesComments[k].value}
                        onChange={e => handleChangeFileComment(k, e.target.value)}
                      />
                    </td>
                  )}
                  <td className="text-center align-middle">
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => handleDeleteFile(k)}
                    >
                      <i className="fas fa-times">x</i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          {existingFiles.map((file, k) => (
            <File
              key={k}
              extension={file.extension}
              comment={file.comment}
              uri={file.uri}
            />
          ))}
        </Col>
      </Row>
    </>
  );
};

export { File };
export default FileUploadMultiple;
